import { useCallback } from 'react';
import { formatCurrency as formatCurrencyUtil, type FormatCurrencyOptions } from '@/lib/format';
import { usePrivacy } from '@/contexts/PrivacyContext';

export function useFormatCurrency() {
  const { hideValues } = usePrivacy();

  return useCallback(
    (value: number, options: FormatCurrencyOptions = {}) =>
      formatCurrencyUtil(value, { ...options, hidden: hideValues }),
    [hideValues],
  );
}
